import {makeStyles} from "tss-react/mui";
import {Box, FormControl, InputLabel, MenuItem, Select, SelectProps} from "@mui/material";
import {AdminFieldContainer, IProps as AdminFieldContainerProps} from "@/pages/ManagerView/ContentCreation/AdminFieldContainer";
import {useId} from "react";

export type IProps<T> = Omit<AdminFieldContainerProps, "children"> & Omit<SelectProps<T>, "className" | "children" | "error"> & {
	className?: string,
	value: T,
	options: {value: T, label: string}[],
	error?: string
};


const useStyles = makeStyles()((theme) => ({
	adminInputSelect: {},
	requiredAsterisk: {
		color: theme.palette.error.main
	},
	select: {
		minWidth: "200px",
		fieldset: {
			borderColor: theme.palette.grey[200]
		},
		"& svg path": {
			fill:  theme.palette.grey[200]
		}
	}
}));

export const AdminInputSelect = <T extends (string | number | undefined)>({outline, label, error, required, className, options, ...selectProps}: IProps<T>): JSX.Element => {
	const {cx, classes} = useStyles();
	const id = useId();

	return (
		<Box className={cx(classes.adminInputSelect, className)}>
			<AdminFieldContainer error={error} required={required} outline={outline}>
				<FormControl>
					<InputLabel shrink id={`${id}-label`}>
						{label}
						{required && <span className={classes.requiredAsterisk}> *</span>}
					</InputLabel>
					<Select error={!!error} variant="outlined" labelId={`${id}-label`} notched {...selectProps} label="yesy eyssy eyy" className={classes.select} value={selectProps.value}>
						{options.map((e, i) => <MenuItem key={i} value={e.value}>{e.label}</MenuItem>)}
					</Select>
				</FormControl>
			</AdminFieldContainer>
		</Box>

	);
}